import { SubmitButton } from 'components/SubmitButton';
import media from 'style-utils/media-queries';
import styled from 'styled-components';

export const SubmitButtonOtp = styled(SubmitButton)`
  ${({ width = '100%' }) => `
    width:${width};
  `}
  ${({ minWidth = '150px' }) => `
    min-width:${minWidth};
  `}
  
    ${media.desktop`
    width: fit-content;
  `}
`;
